export const PASSWORD_REGEX = {
  upperLower: /(?=.*[a-z])(?=.*[A-Z])/,
  number: /(?=.*[0-9])/,
  specialChar: /(?=.*[!@#$%^&*])/,
};

export const PASSWORD_RULES = {
  required: 'Password is required',
  minLength: {
    value: 8,
    message: 'Minimum 8 characters required',
  },
  maxLength: {
    value: 15,
    message: 'Maximum 15 characters allowed',
  },
  validate: {
    hasUpperLower: (value: string) =>
      PASSWORD_REGEX.upperLower.test(value) ||
      'Must include uppercase & lowercase letter',

    hasNumber: (value: string) =>
      PASSWORD_REGEX.number.test(value) || 'Must include a number',

    hasSpecial: (value: string) =>
      PASSWORD_REGEX.specialChar.test(value) ||
      'Must include a special character',
  },
};

export const getConfirmPasswordRules = (getPassword: () => string) => ({
  required: 'Please confirm password',
  validate: (value: string) =>
    value === getPassword() || 'Passwords do not match',
});
